import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPenPressureIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 1,
			d: "M4 19q4-2 8-7t8-7",
			opacity: .4
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 3,
			d: "M4 19q4-2 8-7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4,
			cy: 19,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		})
	]
});
export default SvgPenPressureIcon;
